import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.ip.request;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_IP_REQUEST',
	method: 'POST',
	url: '/network/ip/request.json',
});

export { actions, reducer, sagas, selectors };
